import { useEffect, useState } from "react";
import FilterMenu from "../../components/FilterMenu";
import { CUMULATION_KEYS, Group_keys, keys, units } from "./Data";
import { ChartType } from "../../models/chart_model";
import { ExchangeColors } from "../Dashboard/Exchange3/FormatData";
import { ReMixChart } from "../../components/recharts/ReMixCharts";
import { renderQuarterTick } from "../../components/recharts/components";
import {
  FormatChartData,
  FormatChartDataWithAverages,
} from "../../components/recharts/functions";
import { DmrcForecastedLoad } from "../../models/dmrc";

export default function TrendAnalysis({
  snapshots,
  selectedSlots,
  selectedStations,
}: {
  snapshots: DmrcForecastedLoad[];
  selectedSlots: {
    value: string;
    label: string;
  }[];
  selectedStations: {
    value: string;
    label: string;
  }[];
}) {
  const [selectedKeys, setSelectedKeys] = useState([keys[0], keys[1]]);
  const [selectedGroupKeys, setSelectedGroupKeys] = useState<any[]>([]);
  const [selectedEntity, setSelectedEntity] = useState<string[]>([]);
  const [selectedUnit, setSelectedUnit] = useState(units[0]);
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [chartKeys, setChartKeys] = useState<string[]>([]);
  const [selectedCumulation, setSelectedCumulation] = useState(
    CUMULATION_KEYS[0]
  );

  useEffect(() => {
    let formatedSnapshot = snapshots;
    if (selectedSlots.length > 0) {
      formatedSnapshot = snapshots.filter(
        (item: { time_slot: { toString: () => string } }) =>
          selectedSlots
            .map((item) => item.value)
            .includes(item.time_slot.toString())
      );
    }
    if (selectedStations.length > 0) {
      formatedSnapshot = snapshots.filter((item: { station__name: string }) =>
        selectedStations.map((item) => item.value).includes(item.station__name)
      );
    }
    if (selectedCumulation !== CUMULATION_KEYS[0]) {
      setSelectedUnit(units[1]);
    }
    const par = {
      keys: selectedKeys.map((item) => item.key),
      groupBy: selectedGroupKeys.map((item) => item.key),
      aggregationKeys: ["demand_mw"],
      data: formatedSnapshot,
      volumeKey: "demand_mwh",
      priceKey: "",
    };
    const cData =
      selectedCumulation === CUMULATION_KEYS[0]
        ? FormatChartDataWithAverages(par)
        : FormatChartData(par);
    console.log(cData);

    setChartData(cData.data);
    setChartKeys(cData.keys);
  }, [
    selectedKeys,
    selectedGroupKeys,
    selectedSlots,
    selectedCumulation,
    snapshots,
    selectedStations,
  ]);

  const _handleUnitSelection = (unitIndex: number) => {
    if (selectedCumulation == CUMULATION_KEYS[1]) return;
    setSelectedUnit(units[unitIndex]);
  };

  const handleKeySelection = (keyIndex: number) => {
    const selectedKey = keys[keyIndex]; // The key to be toggled
    const isSelected = selectedKeys.find(
      (item) => item.key === selectedKey.key
    ); // Check if the key is already selected

    if (isSelected) {
      // If the key is already selected and there are more than one keys selected, remove it
      if (selectedKeys.length > 1) {
        setSelectedKeys(
          selectedKeys
            .filter((item) => item.key !== selectedKey.key)
            .sort((a, b) => a.index - b.index)
        );
      }
    } else {
      // If the key is not selected and there are less than 2 keys selected, add it
      if (selectedKeys.length < 2) {
        setSelectedKeys(
          [...selectedKeys, selectedKey].sort((a, b) => a.index - b.index)
        );
      } else {
        // If 2 keys are already selected, remove the first key and add the new key
        setSelectedKeys(
          [selectedKeys[1], selectedKey].sort((a, b) => a.index - b.index)
        );
      }
    }
  };
  const _handleGroupByChange = (keyIndex: number) => {
    if (selectedGroupKeys.length != 0) {
      setSelectedGroupKeys([]);
    } else {
      setSelectedGroupKeys([Group_keys[keyIndex]]);
    }
  };
  const TrendAnalysisFilter = () => {
    return (
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="Function"
          items={CUMULATION_KEYS.map((item) => item.label)}
          selectedItems={[selectedCumulation.label]}
          onSelect={(item, index) => {
            setSelectedCumulation(CUMULATION_KEYS[index]);
          }}
        />
        <FilterMenu
          title="Interval"
          items={keys.map((item) => item.label)}
          selectedItems={selectedKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            handleKeySelection(index);
          }}
        />
        <FilterMenu
          title="Group By"
          items={Group_keys.map((item) => item.label)}
          selectedItems={selectedGroupKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            _handleGroupByChange(index);
          }}
        />
        <FilterMenu
          title="Unit"
          items={units}
          selectedItems={[selectedUnit]}
          onSelect={(item, index) => {
            _handleUnitSelection(index);
          }}
        />
      </div>
    );
  };
  return (
    <div className="flex flex-row w-full h-full">
      {<TrendAnalysisFilter />}
      <div className="dmrc-chart">
        <div className="dmrc-chart-container">
          <ReMixChart
            chartContainerHeight="100vh"
            data={chartData}
            showSecondYAxis={true}
            isTimeSlot={chartData[0]?.time_slot ? true : false}
            onlyTitle={true}
            xLabel={selectedKeys[0].label}
            //   xLabel="Date"
            xAxisLabelOffset={17}
            rendexSecondXTick={(ti: any) =>
              renderQuarterTick(
                ti,
                selectedKeys.length > 1 ? selectedKeys[0].freq : 96
              )
            }
            xaxisHeight={60}
            secondXAxisHeight={35}
            secondXAxisLabel={
              selectedKeys.length > 1 ? selectedKeys[1].label : undefined
            }
            showBrush={true}
            unit={selectedUnit}
            yAxisLabel={`Volume (${selectedUnit})`}
            secondYAxisLabel="Price(INR)"
            brushIndex={
              chartData.length > 672
                ? { startIndex: 0, endIndex: 672 }
                : {
                    startIndex: 0,
                    endIndex: chartData.length - 1,
                  }
            }
            legends={[
              ...chartKeys
                .map((key, index) => {
                  return {
                    dataKey: key + "_demand_" + selectedUnit.toLowerCase(),
                    type: ChartType.Line,
                    name: key == "" ? "Volume" : key + "",
                    stroke: ExchangeColors[index],
                    legendColor: ExchangeColors[index],
                  };
                })
                .flat(),
            ]}
            xDataKey={selectedKeys[0].key}
            secondXDataKey={
              selectedKeys.length > 1 ? selectedKeys[1].key : undefined
            }
          />
        </div>
      </div>
    </div>
  );
}
